import { TriangleAlert } from 'lucide-react';
import { authErrorMessage } from '../../api/auth-messages.ts';
import { isApiError } from '../../api/errors.ts';
import { Button } from '../ui/button.tsx';

/**
 * Erro = mensagem da API + "tentar de novo" + o código do erro (`spec/17` §4.3 item 3).
 * O `request_id` sai em `data-value` (Geist Mono) e selecionável: é o que o suporte pede.
 * Sem `kit/mono.tsx`: nenhum primitivo de `components/app/*` importa do kit (WEB-117).
 */
export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  // Mesma tradução por `code` de `errorMessageOf`; aqui o `request_id` sai em linha
  // própria, então a mensagem não leva o sufixo.
  const message = isApiError(error)
    ? (authErrorMessage(error.code) ?? error.message)
    : error instanceof Error
      ? error.message
      : 'erro inesperado';
  const requestId = isApiError(error) ? error.requestId : '';

  return (
    <div
      role="alert"
      className="flex flex-col items-center gap-3 rounded-card border border-danger/40 px-6 py-10 text-center"
    >
      <span className="grid size-10 place-items-center rounded-card border border-danger/40 text-danger">
        <TriangleAlert className="size-[18px]" aria-hidden="true" />
      </span>
      <div className="text-16 font-semibold">Não deu para carregar</div>
      <p className="max-w-md text-14 text-muted">{message}</p>
      {requestId !== '' && (
        <p className="text-11 text-faint">
          código do erro: <span className="data-value select-all break-all">{requestId}</span>
        </p>
      )}
      {onRetry !== undefined && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          Tentar de novo
        </Button>
      )}
    </div>
  );
}
